<script>
	import Address from "./Address.svelte";
	import Datepicker from "./Datepicker.svelte";
	import Select from "./Select.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	import { salutationTypes } from "../config";

	export let isRegistrationUpdate = false;
	export let required = false;
	export let disabled = false;
	export let idPrefix = "a" + uuid4().substring(0, 3);
	export let title;
	export let firstName;
	export let surname;
	export let dateOfBirth;
	export let emailAddress;
	export let phoneNumber;
	export let address = null;
</script>

<FormRow>
	<FormColumn cols="2">
		<label for="{idPrefix}_title">Salutation</label>
		<Select
			disabled={disabled || isRegistrationUpdate}
			id="{idPrefix}_title"
			bind:value={title}
			optionList={salutationTypes}
			textProperty="name"
			valueProperty="name"
		></Select>
	</FormColumn>
	<FormColumn cols="5">
		<label for="{idPrefix}_firstName" class:isrequired={required}>First Name</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="text"
			bind:value={firstName}
			id="{idPrefix}_firstName"
			class="form-control"
		/>
	</FormColumn>
	<FormColumn cols="5">
		<label for="{idPrefix}_surname" class:isrequired={required}>Surname</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="text"
			bind:value={surname}
			id="{idPrefix}_surname"
			class="form-control"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="4">
		<label for="{idPrefix}_dob" class:isrequired={required}>Date of Birth</label>
		<Datepicker
			{disabled}
			{required}
			bind:formattedSelected={dateOfBirth}
			defaultToday="true"
			id="{idPrefix}_dob"
			start={new Date(1920, 0, 1)}
			end={new Date(2020, 0, 1)}
			placeholder="e.g. 01/05/1987"
			openOnClass="calendar-pop"
		/>
	</FormColumn>
	<FormColumn cols="4">
		<label for="{idPrefix}_email" class:isrequired={required}>Email Address</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="email"
			bind:value={emailAddress}
			id="{idPrefix}_email"
			class="form-control"
		/>
	</FormColumn>
	<FormColumn cols="4">
		<label for="{idPrefix}_phone" class:isrequired={required}>Phone Number</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="text"
			bind:value={phoneNumber}
			id="{idPrefix}_phone"
			class="form-control"
			phone
		/>
	</FormColumn>
</FormRow>

<Address
	{idPrefix}
	bind:googlePlaceJson={address.GooglePlaceJson}
	bind:formattedAddress={address.FormattedAddress}
	bind:premise={address.Premise}
	bind:subpremise={address.Subpremise}
	bind:street={address.Street}
	bind:suburb={address.Suburb}
	bind:state={address.State}
	bind:postcode={address.Postcode}
	bind:country={address.Country}
	bind:lat={address.Lat}
	bind:lng={address.Lng}
	bind:placeId={address.PlaceId}
	bind:url={address.GoogleMapsUrl}
	disabled={disabled || isRegistrationUpdate}
	{required}
></Address>
